module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "abs",
    attrs: {
      "id": "modal"
    }
  }, [_c('div', {
    staticClass: "ticket-select rel"
  }, [_c('div', {
    staticClass: "rel"
  }, [_c('i', {
    staticClass: "close-dialog",
    on: {
      "click": function($event) {
        _vm.closeDialog();
      }
    }
  })]), _vm._v(" "), _c('h1', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t("configurator.ticket")))]), _vm._v(" "), _vm._l((_vm.tickets), function(ticket) {
    return (ticket !== null) ? _c('div', {
      staticClass: "content-ticket"
    }, [_c('input', {
      directives: [{
        name: "checked",
        rawName: "v-checked",
        value: (_vm.checkedTicketStrip(ticket)),
        expression: "checkedTicketStrip(ticket)"
      }],
      attrs: {
        "id": 'ticket_' + ticket.id,
        "type": "checkbox"
      },
      on: {
        "click": function($event) {
          _vm.addTicket(ticket, $event.target.checked);
        }
      }
    }), _c('label', {
      attrs: {
        "for": 'ticket_' + ticket.id
      }
    }, [_vm._v(_vm._s(_vm.getTranslate(ticket.terms.name)))])]) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticClass: "buttonbar"
  }, [_c('button', {
    staticClass: "btn",
    on: {
      "click": _vm.valid
    }
  }, [_vm._v("OK")])])], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-13c73838","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/configurator/TicketStripSelect.vue
// module id = 3027
// module chunks = 0